import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import ErrorBoundary from '../../../../ErrorBoundary';
import MobileThumbContent from '../_partials/MobileThumbContent';
import TopInfoBar from '../_partials/TopInfoBar';
import BottomInfoBar from '../_partials/BottomInfoBar';
import s from './Default.scss';
var TOP_EXTRA_HEIGHT = parseInt(s['topExtrasHeight'], 10);
var BOTTOM_EXTRA_HEIGHT = parseInt(s['bottomExtrasHeight'], 10);
var MINIMUM_DUMBO_HEIGHT_FOR_EXTRAS = 50; // this one is pulled from behind
export var EXTRAS_HEIGHT = TOP_EXTRA_HEIGHT + BOTTOM_EXTRA_HEIGHT;
var DefaultMobileThumb = function (_a) {
    var className = _a.className, deviation = _a.deviation, height = _a.height, responsive = _a.responsive, style = _a.style, width = _a.width, extraActions = _a.extraActions;
    var hasEnoughHeightForExtras = !!height && height > EXTRAS_HEIGHT + MINIMUM_DUMBO_HEIGHT_FOR_EXTRAS;
    return (React.createElement(Section, { className: classnames(s['root'], hasEnoughHeightForExtras && s['with-extras'], className), style: __assign({ width: width, height: height }, style), "data-hook": BiDataHook.DEVIATION_STD_THUMB },
        React.createElement(ErrorBoundary, { debugComponent: "DefaultMobileThumb" }, hasEnoughHeightForExtras ? (React.createElement(React.Fragment, null,
            React.createElement(TopInfoBar, { deviation: deviation, extraActions: extraActions, className: s['top-extras'] }),
            React.createElement(MobileThumbContent, { deviation: deviation, width: width, height: height - EXTRAS_HEIGHT, responsive: responsive }),
            React.createElement(BottomInfoBar, { deviation: deviation, className: s['bottom-extras'] }))) : (React.createElement(MobileThumbContent, { deviation: deviation, width: width, height: height, responsive: responsive })))));
};
DefaultMobileThumb.displayName = 'DefaultMobileThumb';
export default DefaultMobileThumb;
//# sourceMappingURL=Default.js.map